import { Support } from "./Support";

/**Build out the support request page */
export const BuildRequestSupportPage = () =>
{
	let support = new Support();
	support.InitializeSupportRequest();
};